import styles from './Section.module.scss';
import { SectionProps } from './type';

export function Section({ children, className }: SectionProps): JSX.Element {
    return <div className={`${styles.section} ${className}`}>{children}</div>;
}
